import React, { useEffect, useState } from 'react';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';
import { useLocation, useParams } from 'react-router-dom';
import { useFacilitiesApi } from '../../../../store/api/hooks/facilitiesApiHook';
import { getPermissionInfo, showDate } from '../../../../_common/functions';
import { DATE_FORMAT } from '../../../../_common/constant';
import { MAP_KEY } from '../../../../_config';
import Currency from '../../../../components/currency';
import { AgGridReact } from 'ag-grid-react';
import { titleCell } from '../../../../components/elements/function';
import Icon from '../../../../components/icons';
import Loader from '../../../../components/loader';
import Button from '../../../../components/elements/button';
import ModalWrapper from '../../../../components/modalWrapper';
import CreatePreferredVendor from './createPreferredVendor';
import moment from 'moment';
import { useDialog } from '../../../../store/api/hooks/dialogHook';
import { useSpearPartsApi } from '../../../../store/api/hooks/spearPartsApiHook';
import toast from 'react-hot-toast';
import { on } from 'events';
import { useAppLoader } from '../../../../_common/pageLoader/appLoaderHook';
import { useUserSelector } from '../../../../store/selectors/userSelector';

interface genProps {
  partDetails: any;
  onUpdate?: (data: Array<any>) => void;
}
const General: React.FC<genProps> = ({ partDetails, onUpdate = () => { } }) => {
  const location = useLocation();
  const loggedinuser: any = useUserSelector();
  const params: any = useParams();
  const { showLoader, hideLoader } = useAppLoader();
  console.log('partDetails', partDetails);
  const facilityApi: any = useFacilitiesApi();
  const sparePartsAPI = useSpearPartsApi();
  const partsApi = useSpearPartsApi();
  const { confirm } = useDialog();

  const addPreferredVendorModalRef = React.useRef<any>(null);
  const vendorColumnDefs = [
    { headerName: ``, field: 'isPreferred', width: 62, headerClass: 'bg-[#f0f0f0] text-center', cellClass: `text-center`, cellRenderer: (data: any) => <p>{data.value ? (<button className={`cursor-pointer`} onClick={() => { onTogglePreferredVendor(data, false) }}><Icon name={`starfill`} className={'text-yellow-500'} size={1} /></button>) : (<button className={`cursor-pointer`} onClick={() => { onTogglePreferredVendor(data, true) }}><Icon name={`starfill`} className='text-slate-400' size={1} /></button>)}</p> },
    { headerName: `Vendor Part Code`, field: 'vendorPartCode', width: 200, headerClass: 'bg-[#f0f0f0]', cellRenderer: (data: any) => <p>{data.value || '--'}</p> },
    { headerName: `Vendor Name`, field: 'vendorName', headerClass: 'bg-[#f0f0f0]', flex: 1, minWidth: 250, cellRenderer: titleCell },
    { headerName: `Cost per unit`, field: 'costPerUnit', width: 150, headerClass: 'bg-[#f0f0f0] ag-header-cell-right', sortable: false, cellClass: 'ag-right-aligned-cell', cellRenderer: (data: any) => <p><Currency currency={`USD`} value={+data.value} /></p> },
    { headerName: `Added By`, field: 'addedByName', headerClass: 'bg-[#f0f0f0]', width: 175, cellRenderer: (data: any) => <p>{data.value || '--'}</p> },
    { headerName: `Added By Datetime`, field: 'addedDate', headerClass: 'bg-[#f0f0f0] ag-header-cell-right', cellClass: 'ag-right-aligned-cell', width: 200, cellRenderer: (data: any) => <p>{moment.utc(data.value).local().format(`MM/DD/YYYY HH:mm A`) || '--'}</p> },
    {
      headerName: `Action`, field: `action`, headerClass: `bg-[#f0f0f0] text-right`, width: 92, cellRenderer: (data: any) =>
        <div className={`flex items-center gap-3 justify-center h-full`}>
          <a className={`text-slate-700`} onClick={() => {
            onEditPreferredVendor(data);
          }}>
            <Icon name="edit" size={0.9} />
          </a>
          <a className={`text-red-700`} onClick={() => {
            onDeletePreferredVendor(data);
          }}>
            <Icon name={`delete`} size={0.9} />
          </a>
          
        </div>
    }
  ];
  const [preferredVendorsGridApi, setPreferredVendorsGridApi] = useState<any>(null);
  const [preferredGridColumnApi, setPreferredGridColumnApi] = useState<any>(null);
  const [editVendorData, setEditVendorData] = useState<any>(null);


  const [rowData, setrowData] = useState<any>(null)
  const defaultLatitude = 40.712776; // Example default latitude (New York)
  const defaultLongitude = -74.005974; // Example default longitude (New York)

  const getAssetsList = (assetID: any) => {
    const payload: any = {
      FacilityID: partDetails?.facilityID
    };

    if (partDetails?.facilityID) {
      facilityApi.getFacilityList(payload, (resp: any) => {
        console.log("daaadd", resp.facilityList[0]);
        setrowData(resp?.facilityList ? resp.facilityList[0] : []);
        console.log("rowData", rowData)
      }, (error: any) => {
      });
    }
  };

  const onPreferredVendorGridReady = (params: any) => {
    setPreferredVendorsGridApi(params.api);
    setPreferredGridColumnApi(params.columnApi);
  };

  const onPreferredVendorRowClicked = (params: any) => {
    console.log("onPreferredVendorRowClicked", params);
  }

  const onTogglePreferredVendor = async (params: any, isPreferred: boolean) => {
    const rowData = params.data;
    const payload = {
      partsID: rowData.partsID,
      vendorID: rowData.vendorID,
      isPreferred: isPreferred,
      vendorPartCode: rowData.vendorPartCode,
      costPerUnit: +rowData.costPerUnit
    };
    showLoader();
    const vendorresp: any = await new Promise((resolve, reject) => {
      partsApi.SavePartsVendorMap(payload, (data: any) => {
        resolve(data);
      }, (error: any) => {
        reject(error);
      });
    }).catch((error: any) => {
      console.error("Error saving vendor map:", error);
      return null;
    });
    hideLoader();
    if (vendorresp && vendorresp.hasOwnProperty(`successful`) && vendorresp.successful) {
      toast.success(vendorresp.message || `Vendor preferrence saved Successfully`);
      onUpdate([]);
    } else {
      toast.error(vendorresp.message || `Failed to set preferrence for vendor`);
    }
  };

  const onEditPreferredVendor = (params: any) => {
    if (!getPermissionInfo(location.pathname, "Manage Prefered Vendor", loggedinuser)) {
      toast.error("You don't have permission to access this form.");
      return;
    }
    const rowData = params.data;
    setEditVendorData(rowData);
    if (addPreferredVendorModalRef.current) {
      addPreferredVendorModalRef.current.open();
    }
  };

  const onDeletePreferredVendor = (params: any) => {
    console.log("Delete Params", params);
    const rowData = params.data;
    console.log("rowData?.isPreferred", rowData?.isPreferred);
    if (!rowData?.isPreferred) {
      confirm({
        type: `warn`,
        title: `Confirmation`,
        message: `Are you sure you want to delete this vendor?`,
        onConfirm: async () => {
          const delresp: any = await new Promise((resolve, reject) => {
            console.log("Row Data", rowData);
            sparePartsAPI.DeletePartsVendorMap({ partsID: rowData?.partsID, vendorID: rowData.vendorID }, (data: any) => {
              resolve(data);
            }, (error: any) => {
              reject(error);
            });
          }).catch((error: any) => {
            console.error("Error deleting vendor map:", error);
            return null;
          });
          if (delresp && delresp.hasOwnProperty(`successful`) && delresp.successful) {
            toast.success(delresp.message || `Vendor Deleted Successfully`);
            onUpdate([]);
          } else {
            toast.error(delresp.message || `Failed to Delete Vendor`);
          }
        }
      });
    } else {
      toast.error(`Cannot delete preferred vendor! Please select another vendor as preferred before deleting this one.`);
    }
  };

  useEffect(() => {
    if (params.id) {
      getAssetsList(params.id);
    }
  }, [partDetails]);


  return (
    <div className='flex h-full'>
      <div className='pt-4 grow'>

        <div className='grid grid-cols-2 gap-6'>
          <div>
            <h4 className='font-semibold text-[0.938rem] border-b border-gray-200 py-4'>General Information</h4>
            <div className='flex py-4 border-b border-gray-200 items-center flex-row text-[0.938rem]'>
              <div className='w-[12.5rem] text-[#767676]'><div className='mr-2'>Part Code</div></div>
              <div className='w-3/4 text-[#323233]'>
                {partDetails?.partsCode ? partDetails?.partsCode : '-'}
              </div>
            </div>
            <div className='py-4 border-b border-gray-200 items-center flex flex-row text-[0.938rem]'>
              <div className='w-[12.5rem] text-[#767676]'> <div className='mr-2'>Part Name</div> </div>
              <div className='w-3/4 text-[#323233]'>
                {partDetails?.sparePartsName ? partDetails?.sparePartsName : '-'}
              </div>
            </div>
            <div className='py-4 border-b border-gray-200 items-center flex flex-row text-[0.938rem]'>
              <div className='w-[12.5rem] text-[#767676]'> <div className='mr-2'>Description</div> </div>
              <div className='w-3/4 text-[#323233]'>
                {partDetails?.partsDescription ? partDetails?.partsDescription : '-'}
              </div>
            </div>
            <div className='py-4 border-b border-gray-200 items-center flex flex-row text-[0.938rem]'>
              <div className='w-[12.5rem] text-[#767676]'> <div className='mr-2'>Category</div> </div>
              <div className='w-3/4 text-[#323233]'>
                {partDetails?.partsCategoryName ? partDetails?.partsCategoryName : '-'}
              </div>
            </div>
            {/* <div className='py-4 border-b border-gray-200 items-center flex flex-row text-[0.938rem]'>
              <div className='w-[12.5rem] text-[#767676]'> <div className='mr-2'>Vendor Part Code</div> </div>
              <div className='w-3/4 text-[#323233]'>
                {partDetails?.vendorPartCode ? partDetails?.vendorPartCode : '-'}
              </div>
            </div> */}
          </div>
          <div>
            <h4 className='font-semibold text-[0.938rem] border-b border-gray-200 py-4'>Financial Summary</h4>
            <div className='flex py-4 border-b border-gray-200 items-center flex-row text-[0.938rem]'>
              <div className='w-[12.5rem] text-[#767676]'><div className='mr-2'>Avg. Unit Cost  </div></div>
              {/* <div className='w-3/4 text-[#323233]'>{partDetails?.costPerUnit ? <Currency currency="USD" value={partDetails.costPerUnit} /> : '-'}</div> */}
              <div className='w-3/4 text-[#323233]'>${partDetails?.avgUnitCost ? Number(partDetails?.avgUnitCost).toFixed(2) : (0.0).toFixed(2)}</div>
            </div>
            <div className='flex py-4 border-b border-gray-200 items-center flex-row text-[0.938rem]'>
              <div className='w-[12.5rem] text-[#767676]'><div className='mr-2'>Last Order Number </div></div>
              <div className='w-3/4 text-[#323233]'>{partDetails?.lastOrderNumber ? partDetails?.lastOrderNumber : '-'}</div>
            </div>
            <div className='flex py-4 border-b border-gray-200 items-center flex-row text-[0.938rem]'>
              <div className='w-[12.5rem] text-[#767676]'><div className='mr-2'>Last Order Date </div></div>
              <div className='w-3/4 text-[#323233]'>{partDetails?.lastOrdeDate ? showDate(partDetails?.lastOrdeDate, DATE_FORMAT) : '-'}</div>
            </div>
            <div className='flex py-4 border-b border-gray-200 items-center flex-row text-[0.938rem]'>
              <div className='w-[12.5rem] text-[#767676]'><div className='mr-2'>Last Received Date </div></div>
              <div className='w-3/4 text-[#323233]'>{partDetails?.lastReceivedDate ? showDate(partDetails?.lastReceivedDate, DATE_FORMAT) : '-'}</div>
            </div>
            <div className='flex py-4 border-b border-gray-200 items-center flex-row text-[0.938rem]'>
              <div className='w-[12.5rem] text-[#767676]'><div className='mr-2'>Min Stock Qty. </div></div>
              <div className='w-3/4 text-[#323233]'>
                {partDetails?.minStock ? partDetails?.minStock + " " + partDetails?.unitName : '-'}
              </div>
            </div>
            <div className='flex py-4 border-b border-gray-200 items-center flex-row text-[0.938rem]'>
              <div className='w-[12.5rem] text-[#767676]'><div className='mr-2'>Max Stock Qty. </div></div>
              <div className='w-3/4 text-[#323233]'>
                {partDetails?.maxStock ? partDetails?.maxStock + " " + partDetails?.unitName : '-'}
              </div>
            </div>
            <div className='flex py-4 border-b border-gray-200 items-center flex-row text-[0.938rem]'>
              <div className='w-[12.5rem] text-[#767676]'><div className='mr-2'>Total Stock on hand </div></div>
              <div className='w-3/4 text-[#323233]'>
                {partDetails?.currenctStock ? partDetails?.currenctStock + " " + partDetails?.unitName : '-'}
              </div>
            </div>
          </div>
        </div>


        <div className={`mt-5 pr-5`}>
          <div className={`flex items-center justify-between`}>
            <h4 className='font-semibold text-[0.938rem] py-4'>Preferred Vendors</h4>
            <Button theme={`primary`} customstyle={{ paddingTop: `5px`, paddingBottom: `5px`, paddingLeft: `10px`, paddingRight: `10px` }} childstyle={{}} onClick={() => {
              if (!getPermissionInfo(location.pathname, "Manage Prefered Vendor", loggedinuser)) {
                toast.error("You don’t have permission to access this form.");
                return;
              }
              setEditVendorData(null);
              if (addPreferredVendorModalRef.current) {
                addPreferredVendorModalRef.current.open();
              }
            }} disabled={!getPermissionInfo(location.pathname, "Manage Prefered Vendor", loggedinuser)}>Add new</Button>
          </div>
          <div className={``}>
            <AgGridReact
              columnDefs={vendorColumnDefs as any} // Pass columnDefs
              rowData={partDetails?.vendors || []} // Pass rowData
              pagination={false}
              rowSelection={`single`}
              onGridReady={onPreferredVendorGridReady}
              domLayout="autoHeight"
              onRowClicked={onPreferredVendorRowClicked}
              loadingOverlayComponent={Loader}
              noRowsOverlayComponent={() => (
                <div className="flex items-center justify-center h-full">
                  <div className="text-center text-gray-500">
                    <div className="text-lg font-medium">No Data Found</div>
                  </div>
                </div>
              )}
            />
          </div>
          <ModalWrapper ref={addPreferredVendorModalRef}>
            <CreatePreferredVendor parts={partDetails} data={editVendorData} onCreate={() => {
              addPreferredVendorModalRef.current?.close();
              setEditVendorData(null);
              onUpdate([]);
            }} onCancel={() => {
              addPreferredVendorModalRef.current?.close();
              setEditVendorData(null);
            }} />
          </ModalWrapper>
        </div>

        <br />
      </div>
      <div className='min-w-[19.5rem] w-[19.5rem] max-w-[19.5rem] p-[1.125rem] overflow-y-auto border-l border-gray-200'>
        <div className='max-w-[17.125rem] m-auto'>
          <img className='border border-gray-200 rounded-md' src={partDetails?.imageFullPath} alt="" />
          <h4 className='font-semibold text-[0.938rem] pt-5 pb-2'>Location</h4>
          <p className='text-[0.938rem] text-[#323233]'>{partDetails?.facilityName ? partDetails?.facilityName : '-'} </p>

          <LoadScript googleMapsApiKey={MAP_KEY}> {/* Replace with your API key */}
            {rowData &&

              <GoogleMap
                mapContainerStyle={{
                  width: '100%',
                  height: '200px',
                }}
                center={{ lat: rowData?.latitude ?? defaultLatitude, lng: rowData?.longitude ?? defaultLongitude }}
                zoom={15} // Adjust zoom level as needed
                mapTypeId="satellite"
              >

                <Marker position={{ lat: rowData?.latitude ?? defaultLatitude, lng: rowData?.longitude ?? defaultLongitude }} />
              </GoogleMap>
            }


          </LoadScript>
          {/* <img className='mt-2' src={mapImg} alt="" /> */}
          {/* <div className='py-4 border-b border-gray-200 items-center flex flex-row text-[0.938rem]'>
            <div className='w-[12.5rem] text-[#767676]'> <div className='mr-2'>
              {partDetails?.facilityName ? partDetails?.facilityName : '-'}

            </div> </div>
            <div className='w-3/4 text-[#323233]'>Paultry</div>
          </div> */}
          <div className='py-4 border-b border-gray-200 items-center flex flex-row text-[0.938rem]'>
            <div className='w-[12.5rem] text-[#767676]'> <div className='mr-2'>  Status</div> </div>
            <div className='w-3/4 text-[#323233]'>
              {partDetails?.partsStatusName ? partDetails?.partsStatusName : '-'}
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default General;